import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCoursesByUser, getFeaturedCourses } from "../../../redux/features/course/courseService";
import styles from './index.module.css';
import SkeletonCourseCard from "../../../components/Skeleton/CourseCardSekeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCalendarCheck } from "@fortawesome/free-regular-svg-icons";
import { selectUserDetails } from "../../../redux/features/auth/authSlice";

const Courses = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isCoursesLoading, courses } = useSelector((state) => state.course.featuredCourses);
    const { roleName } = useSelector(selectUserDetails);
    const { isPurchasedCoursesLoading, purchasedCourses } = useSelector((state) => state.course.purchasedCourses);

    const fetchFeaturedCourses = useCallback(
        (filters = {}) => {
            const params = {
                skip: 0,
                limit: 3,
                ...filters,
            };
            dispatch(getFeaturedCourses(params));
        },
        [dispatch]
    );

    useEffect(() => {
        fetchFeaturedCourses();
    }, [fetchFeaturedCourses]);

    useEffect(() => {
        if (roleName === 'user') {
            dispatch(getCoursesByUser());
        }
    }, [dispatch, roleName]);

    const isPurchased = (courseId) => {
        return purchasedCourses?.some(
            (pc) => pc?.course?.id === courseId
        );
    };

    const openCourse = (slug) => {
        navigate(`/courses/${slug}`);
    }

    const openMyCourse = (slug) => {
        navigate(`/my-courses/${slug}`);
    }

    const openMentor = (id) => {
        navigate(`/mentors/${id}`);
    }

    return (
        <div className={`main-container`}>
            <div className={`container-content`}>
                <>
                    {isCoursesLoading ? (
                        <div className={styles.homeContainer}>
                            <div className={`main-container`}>
                                <div className={`container-content`}>
                                    <div className={styles.homeHeader}>
                                    </div>
                                    <div className={styles.courseList}>
                                        {Array.from({ length: 3 }).map((_, index) => (
                                            <SkeletonCourseCard key={index} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        courses?.length > 0 &&
                        <div className={styles.homeContainer}>
                            <div className={`main-container`}>
                                <div className={`container-content`}>
                                    <div className={styles.homeHeader}>
                                    </div>
                                    <div className={styles.courseList}>
                                        {courses?.map((course) => (
                                            <div className={styles.courseBoxCard} key={course?.id}>
                                                <div className={styles.imageWrapper}>
                                                    <img src={course?.image_url} alt="Sample" className={styles.courseImg} />
                                                    <span className={styles.imageLabel}>{course?.course_category?.name}</span>
                                                </div>
                                                <div className={`${styles.detailscard}`}>
                                                    <div className={styles.courseDetails}>
                                                        <p className={styles.coursetitle}>{course?.title}</p>
                                                        <p className={styles.courseDescription}>{course?.description?.split(" ").slice(0, 10).join(" ") + "..."}</p>
                                                        <p className={styles.userName} onClick={() => openMentor(course?.user?.id)}>{course?.user?.full_name}</p>
                                                        <p className={styles.detailsRow}><FontAwesomeIcon icon={faCalendarCheck} className={styles.rowIcon} /> {course?.last_update}</p>
                                                        <p className={styles.detailsRow}><FontAwesomeIcon icon={faBell} className={styles.rowIcon} /> {course?.last_update}</p>
                                                        <div className={styles.bottomRow}>
                                                            <span className={styles.price}>Rs. {course?.price.toFixed(2)}</span>

                                                            {/* ✅ Resume if purchased, Register otherwise */}
                                                            {isPurchased(course?.id) ? (
                                                                <button
                                                                    type="button"
                                                                    className={styles.buyBtn}
                                                                    onClick={() => openMyCourse(course.slug)}
                                                                >
                                                                    Resume
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className={styles.buyBtn}
                                                                    onClick={() => openCourse(course.slug)}
                                                                >
                                                                    Register
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            </div>
        </div>
    )
}

export default Courses;